export const PocketsRoutes = {
    ROOT: "/pockets",
    SUMMARY: "/pockets/summary",
    SIGNING: "/pockets/signing",
    SUCCESS: "/pockets/success",
    ERROR_FEATURE_NOT_AVAILABLE: "/pockets/unavailable",
    PDF: "/pockets/pdf",
};



// WEBPACK FOOTER //
// ./src/components/pockets/PocketsRoutes.ts